import {CountUp} from "./countUp";

const stats = document.querySelectorAll('.stats-list .flex > div');

// Loop through each stat element and animate the count-up effect
stats.forEach(function (stat) {
  let options = {
    useEasing: true,
    useGrouping: true,
    separator: ',',
    decimal: '.',
    prefix: '',
    suffix: '',
    enableScrollSpy: true
  };

  // Get the text from the h2 element
  const text = stat.querySelector('h2').textContent;
  const id = stat.querySelector('h2').getAttribute('id');

  // Extract the prefix, value, and suffix using regular expressions
  const regex = /^([^\d]*)(\d+\.?\d*)([^\d]*)$/;
  const match = text.match(regex);
  let numericValue;
  // Set the options prefix and suffix based on the extracted values

  if (match) {
    options.prefix = match[1];
    options.suffix = match[3];

    // Parse the numeric value
    numericValue = parseFloat(match[2].replace(/[^0-9\.]+/g, ''));
  } else {
    numericValue = parseFloat(text);
  }
  // Initialize CountUp with options
  new CountUp(id, numericValue, options);
});
